export class LogSource {
    'id';
    'name';
    'type';
    'locationResource';
    'location';
    'attachedPolicyId';
    'isIndexed';
    'createdAt';
    'updatedAt';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "LogSourceTypeEnum",
            "format": ""
        },
        {
            "name": "locationResource",
            "baseName": "locationResource",
            "type": "LlgLocationResource",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "LogSourceLocation",
            "format": ""
        },
        {
            "name": "attachedPolicyId",
            "baseName": "attachedPolicyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "isIndexed",
            "baseName": "isIndexed",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return LogSource.attributeTypeMap;
    }
    constructor() {
    }
}
export var LogSourceTypeEnum;
(function (LogSourceTypeEnum) {
    LogSourceTypeEnum["Cloudtrail"] = "CLOUDTRAIL";
    LogSourceTypeEnum["Datadog"] = "DATADOG";
    LogSourceTypeEnum["Cloudwatch"] = "CLOUDWATCH";
    LogSourceTypeEnum["Splunk"] = "SPLUNK";
    LogSourceTypeEnum["GcpCloudLogging"] = "GCP_CLOUD_LOGGING";
})(LogSourceTypeEnum || (LogSourceTypeEnum = {}));
